import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { requestHandoff } from './handoff.js';
import { curediaPathFromLegacy } from './paths.js';

/**
 * Old ``/pharma/...`` URLs on Taskydo. Sends the signed-in user to the
 * matching Curedia page already logged in.
 */
export default function ProductHandoffRedirect({ target = 'curedia' }) {
  const location = useLocation();
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    const next = curediaPathFromLegacy(`${location.pathname}${location.search || ''}`);
    requestHandoff(target, next)
      .then((data) => {
        if (!cancelled && data.redirect) window.location.assign(data.redirect);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || 'Could not open Curedia.');
      });
    return () => {
      cancelled = true;
    };
  }, [location.pathname, location.search, target]);

  return (
    <div className="ty-fullscreen-center">
      {error ? <p>{error}</p> : <div className="ty-spinner" aria-label="Opening Curedia" />}
    </div>
  );
}
